import type { WebapiEndpointBuilder } from '@/api/webapi.ts';

interface GetDateFromTenorParams {
  tenor: string;
  currencyPair: string;
}

export function getDateFromTenor(builder: WebapiEndpointBuilder) {
  return builder.query<string, GetDateFromTenorParams>({
    keepUnusedDataFor: 3600, // referential data, does not change often
    query: ({ tenor, currencyPair }) => ({
      url: `/dates/from-tenor/${tenor}?currencyPair=${encodeURIComponent(currencyPair)}`,
      method: 'GET',
    }),
  });
}
